import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const removeUserFromProject = api(({ userId, projectId, clientId } = {}) =>
    mutate(
        gql`
            mutation RemoveUserFromProject($userId: String, $projectId: String, $clientId: String) {
                removeUserFromProject(userId: $userId, projectId: $projectId, clientId: $clientId)
            }
        `,
        { userId, projectId, clientId },
        { returns: "removeUserFromProject" }
    )
)
